import React from 'react';
import PressReleaseLayout from 'components/PressReleaseLayout';

function Content() {
  const thisYear = new Date().getFullYear();

  return (
    <PressReleaseLayout>
      {({ Data, currentCategory, currentYear }) => (
        <div>
          {Data.map((post, index) => {
            let date = post.Release.split('-');
            const categories = Array.isArray(post.category)
              ? post.category.join(',').split(',').map((cat) => cat.trim())
              : post.category.split(',').map((cat) => cat.trim());

            const showPost =
              (currentCategory === 'latest' && parseInt(post.Year) === thisYear) ||
              (currentCategory === 'corporate' &&
                (categories.includes('業績発表') || categories.includes('企業情報'))) ||
              (currentCategory === 'product' && categories.includes('製品・疾患')) ||
              (currentCategory === 'socialimpact' && categories.includes('ソーシャルインパクト')) ||
              (currentCategory === 'year' && parseInt(post.Year) === currentYear);

            if (showPost) {
              return (
                <div key={index}>
                  <h3>
                    {date[0]}年{date[1]}月{date[2]}日
                  </h3>
                  <p>
                    <a
                      className="pdf latest-story"
                      href={'/jp/previewPDF/' + post.Year + '/' + post.FileName}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
                      {post.Title}{' '}
                    </a>
                  </p>
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
      )}
    </PressReleaseLayout>
  );
}

export default Content;
